export function Pill({ label }: { label: string }) {
  return (
    <span className="pill">
      <span className="dot" />
      {label}
    </span>
  );
}
